if (!customElements.get("multiple-product-tabs")) {
  customElements.define(
    "multiple-product-tabs",
    class LocationSelectorWrapper extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          banner_swiper: this.querySelector(".kp__banner-main"),
          banners: this.querySelectorAll(".kp__banner-item"),
          swiper_prev: this.querySelector("[is='prev-button']"),
          swiper_next: this.querySelector("[is='next-button']"),
          tabs: this.querySelectorAll(".kp__tab-item"),
          panes_swiper: this.querySelector(".kp__product-list"),
          panes: this.querySelectorAll(".kp__product-item"),
        };
        this.init();
        this.autoplay();
        this.bindSwiperControl();
        this.subscribeListScroll();
      }

      init() {
        if (this.elements.panes.length <= 0) {
          return;
        }
        if (this.elements.tabs.length <= 0) {
          this.elements.panes[0].classList.add("active");
          return;
        }
        this.elements.tabs.forEach((tab, index) => {
          if (index == 0) {
            tab.classList.add("active");
            document.querySelector(`#pane__${tab.dataset.id}`).classList.add("active");
          }
          tab.addEventListener("click", (e) => {
            this.elements.tabs.forEach((tab) => {
              tab.classList.remove("active");
            });
            e.target.classList.add("active");
            this.elements.panes.forEach((pane) => {
              pane.classList.remove("active");
            });
            document.querySelector(`#pane__${e.target.dataset.id}`).classList.add("active");
          });
        });
      }

      autoplay() {
        if (this.elements.banners.length <= 1) {
          return;
        }
        this.elements.banner_swiper.addEventListener("animationiteration", (ev) => {
          // 轮播逻辑
          this.scrollView("right");
        });
      }

      bindSwiperControl() {
        if (this.elements.swiper_prev && this.elements.swiper_next) {
          this.elements.swiper_prev.addEventListener("click", (e) => {
            this.scrollView("left");
          });
          this.elements.swiper_next.addEventListener("click", (e) => {
            this.scrollView("right");
          });
        }
      }

      scrollView(direction) {
        const _swiper = this.elements.banner_swiper;
        const _prev = this.elements.swiper_prev;
        const _next = this.elements.swiper_next;
        if (direction == "left") {
          _next.removeAttribute("disabled");
          if (_swiper.scrollLeft - _swiper.offsetWidth <= 0) {
            _prev.setAttribute("disabled", true);
          }
          _swiper.scrollBy({
            left: -_swiper.offsetWidth,
            behavior: "smooth",
          });
        } else {
          _prev.removeAttribute("disabled");
          if (_swiper.offsetWidth + _swiper.scrollLeft >= _swiper.scrollWidth) {
            _prev.setAttribute("disabled", true);
            _next.removeAttribute("disabled");
            _swiper.scrollTo({
              left: 0,
              behavior: "smooth",
            });
          } else {
            if (_swiper.offsetWidth * 2 + _swiper.scrollLeft >= _swiper.scrollWidth) {
              _next.setAttribute("disabled", true);
            } else {
              _next.removeAttribute("disabled");
            }
            _swiper.scrollBy({
              left: _swiper.offsetWidth,
              behavior: "smooth",
            });
          }
        }
      }

      subscribeListScroll() {
        this.elements.panes_swiper.addEventListener("scroll", (e) => {
          const _width = this.querySelector(".kp__product-item").offsetWidth;
          const _left = this.elements.panes_swiper.scrollLeft;
          const index = Math.round(_left / _width);
          this.querySelector(".kp__product-item.active").classList.remove("active");
          this.elements.panes[index].classList.add("active");
        });
      }
    }
  );
}
